import { StatusSignedEnum } from 'src/app/shared/enum/statusSigned.enum';
import { TypeSignatureEnum } from 'src/app/shared/enum/type-signature';
import { IPaper, IPaperKanban } from 'src/app/shared/models/paper.model';
import { Tag } from 'src/app/shared/models/tag';
import TagUtil from 'src/app/shared/utils/paper-tag.util';

export namespace NSendComponentModel {
  export class Paper implements IPaperKanban{
    public id: number;

    public typeSignature: TypeSignatureEnum;

    public date: string;

    public signed: number;

    public totalSign: number;

    public subject: string;

    public fullySigned: boolean;

    public tags: Tag[];

    constructor(pPaper: IPaper) {
      this.id = pPaper.paperId;
      this.typeSignature = TagUtil.formatTypeSignature(pPaper.signatureType);
      this.date = pPaper.createdAt;
      this.signed = pPaper.qtdAssinados;
      this.totalSign = pPaper.qtdTotalAssinaturas;
      this.subject = pPaper.subject;
      this.fullySigned = pPaper.status === StatusSignedEnum.SIGNED;
      this.tags = TagUtil.formatTag(pPaper.tags);
    }
  }
}
